class GlossaryIngredients extends HTMLElement {
  constructor(){
      super();

      // get ingredient data
      const dataNode = this.querySelector('[data-glossary-data]');
      this.data = dataNode ? JSON.parse(dataNode.innerHTML) : {};
      this.sortedData = '';

      // get dom nodes
      this.navList = this.querySelector('.js-nav-list');
      this.categoryList = this.querySelector('.js-category-list');
      this.ingredientList = this.querySelector('.js-ingredient-list');
      this.ingredientLinks = this.querySelectorAll('.js-ingredient-link');
      this.ingredientItems = this.querySelectorAll('.js-ingredient-item');
      this.backArrow = this.querySelector('.js-back-arrow');

      this.ingredientOverlay = this.querySelector('.js-ingredient-overlay');
      this.ingredientCard = this.querySelector('.js-ingredient-card');
      this.cardTemplate = document.getElementById('ingredient-template');

      this.getIngredientItems = () => this.querySelectorAll('.js-ingredient-item:not(.hide)');
      this.getIngredientLinks = () => this.querySelectorAll('.js-ingredient-link');
      this.getVisibleIngredientItems = () => this.querySelectorAll('.js-ingredient-item:not(.hide)');

      // initialize the navigation
      this.setNavLinks();
      this.initNavSlider();

      // initialize the category buttons
      this.setCategoryLinks();

      // initialize the ingredients
      this.setBackArrow();

      this.ingredientItems = this.getIngredientItems();
      this.initSlider();
      this.setIngredientLinks();
      this.checkMobileContentDisplay();

      // set the content based on the query string
      if (window.location.search) {
        this.setPushState(window.location.search);
      }
    }

  setNavLinks() {
    const navItems = this.navList.querySelectorAll('.js-nav-item');
    navItems.forEach(navItem => {
      navItem.addEventListener('click', e =>{
        e.preventDefault();
        if ( navItem.parentElement.classList.contains('active') ) {
          this.setContentByLetter(navItem.dataset.letter);
          this.setPushState(navItem.href);
          this.displayIngredientsContent();
        }
      });
    });  
  }

  setCategoryLinks() {
    const categoryItems = this.categoryList.querySelectorAll('.js-category-item');
    categoryItems.forEach(categoryItem => {
      categoryItem.addEventListener('click', e =>{
        e.preventDefault();
        this.setContentByCategory(categoryItem.dataset.category);
        this.setPushState(categoryItem.href);
        this.displayIngredientsContent();
      });
    });
  }

  setNavDisplay() {
    let activeNavItems = [];
    const visibleItems = Array.from(this.getIngredientItems());
    if (visibleItems.length > 0) {
      activeNavItems = visibleItems.map(ingredientItem => ingredientItem.dataset.letter);
    }
    const uniqueNavItems = [...new Set(activeNavItems)];
    Array.from(this.navList.querySelectorAll('.js-nav-item')).forEach(navItem => {
      const parent = navItem.parentNode;
      parent.classList.remove('active');
      if (uniqueNavItems.includes(navItem.dataset.letter)) {
        if (!parent.classList.contains('active')) {
          parent.classList.add('active');
        }
      }
    });
  }

  setBackArrow() {
    this.backArrow.addEventListener('click', e => {
      e.preventDefault();
      this.hideIngredientsContent();
    });
  }

  resetIngredients(clear = false) {
    Array.from(this.ingredientLinks).forEach(ingredientItem => {
      const parent = ingredientItem.parentNode;
      if (clear) {
        parent.classList.remove('hide');
      } else {
        if (!parent.classList.contains('hide')) {
          parent.classList.add('hide');
        }
      }
    });
  }

  setContentByLetter(letter) {
    this.setContentFilter('letter', letter);
  }

  setContentByCategory(category) {
    switch (category) {
      case 'all':
        this.setContentFilter();
        this.setNavDisplay();
        return;
      default:
        this.setContentFilter('category', category);
        this.setNavDisplay();
    }
  }

  setContentFilter(filter, value) {
    this.removeSlider();
    this.resetSlider();
    if (filter && value) {
      Array.from(this.getIngredientLinks()).forEach(ingredientItem => {
        const parent = ingredientItem.parentNode;
        parent.classList.add('hide');
        if (parent.dataset[filter] === value) {
          parent.classList.remove('hide');
        }
      });
    }
    this.initSlider();
    this.setIngredientLinks();
    this.hideIngredientOverlay();
  }

  displayIngredientsContent() {
    if (!this.classList.contains('show-content')) {
      this.classList.add('show-content');
    }
  }

  hideIngredientsContent() {
    if (this.classList.contains('show-content')) {
      this.classList.remove('show-content');
    }
  }

  setPushState(url) {
    const queryString = url.split('?')[1];
    const params = queryString.split('=');
    const currentUrl = window.location.href;
    const hasQueryString = currentUrl.includes('?');

    let newUrl = url;
    if (params[0] == 'letter') {
      // case 'letter' is the only one that needs to be appended to the query string
      if (hasQueryString) {
        const currentParams = currentUrl.split('?')[1].split('=');
        // if the current query string has category, we need to append the letter to the query string
        if (currentParams && currentParams[0] == 'category') {
          // set the new url to category then letter when letter isn't already present
          newUrl = `?${currentParams[0]}=${currentParams[1]}&${params[0]}=${params[1]}`;

          // this is for when a letter is alreay in the query string, replace everything
          // if we don't do this, the query string will keep appending the letter
          const categoryParams = currentUrl.match(/category=(\w*)&/);
          if (categoryParams) {
            newUrl = `?${categoryParams[0]}${params[0]}=${params[1]}`;
          }
        }
      }
    }
    if (params[0] == 'ingredient') {
      let currentParams = currentUrl.split('?')[1];
      const hasCategory = currentParams?.includes('category');
      const hasLetter = currentParams?.includes('letter');

      // remove the ingredient param if it already exists
      const hasIngredientParams = currentUrl.match(/&ingredient=([\w\d-.]*)/);
      if (hasIngredientParams) {
        currentParams = currentParams.replace(hasIngredientParams[0], '');
      }

      // if the current query string has category or letter, we need to append the ingredient to the query string
      if (hasCategory || hasLetter) {
        newUrl = `?${currentParams}&${params[0]}=${params[1]}`;
      }
    }
    window.history.pushState({}, '', newUrl);
  }

  initNavSlider() {
    let config = {
      type       : 'slide',
      perPage    : 26,
      perMove    : 1,
      focus      : 0,
      gap        : '0px',
      width      : '880px',
      throttle   : 1,
      autoplay   : false,
      pagination : false,
      arrows     : false,
      gap        : '6px',
      padding: { 
        left: '0px',
        right: '0px'
      },
      classes: {
        arrows: 'splide__arrows glossary-ingredients__nav-arrows-container',
        arrow : 'splide__arrow glossary-ingredients__nav-arrow-link',
        prev  : 'splide__arrow--prev splide__arrow--prev',
        next  : 'splide__arrow--next splide__arrow--next',
      },
      breakpoints: {
        900: {
          type       : 'loop',
          perPage    : 5,
          arrows     : true,
          width      : '375px',
          padding: { 
            left: '40px',
            right: '40px'
          }
        },
        1250: {
          type       : 'loop',
          perPage    : 16,
          arrows     : true,
          width      : '600px'
        }
      }
    };
    this.Nav = new Splide('#splide-nav', config).mount();
  }

  resetSlider() {
    this.ingredientList.innerHTML = '';
    const pageData = this.data;
    if (pageData.glossaryData) {
      let ingredientList = '';

      // Sort the glossaryData array by the 'Name' property in alphabetical order if not set
      if (this.sortedData.length === 0) {
        this.sortedData = pageData.glossaryData.sort((a, b) => {
          if (a['Name'].toLowerCase() < b['Name'].toLowerCase()) return -1;
          if (a['Name'].toLowerCase() > b['Name'].toLowerCase()) return 1;
          return 0;
        });
      }

      this.sortedData.forEach(ingredient => {
        if (ingredient['Name']) {
          const ingredientLetter = ingredient['Name'].toLowerCase().charAt(0);
          const ingredientCategory = ingredient['Ingredient Type'].toLowerCase().replace(/\s+/g, '-');
          const ingredientTitle = ingredient['Name'].replace(/\s+/g, '-').toLowerCase();
          ingredientList += `
            <li class="glossary-ingredients__item js-ingredient-item splide__slide" data-letter="${ingredientLetter}" data-category="${ingredientCategory}">
              <a class="glossary-ingredients__link js-ingredient-link" data-ingredient="${ingredientTitle}" href="?ingredient=${ingredientTitle}">${ingredient.Name}</a>
            </li>
          `;
        }
      });
      this.ingredientList.insertAdjacentHTML('beforeend', ingredientList);
    }
  }

  initSlider() {
    let config = {
      type       : 'loop',
      perPage    : 9,
      perMove    : 1,
      focus      : 0,
      direction  : 'ttb',
      gap        : '2.5rem',
      height     : '875px', 
      throttle   : 1,
      autoplay   : false,
      pagination : false,
      arrows     : true,
      padding: { 
        top: '2.5rem',
        bottom: '2.5rem'
      }
    };
    if (this.getVisibleIngredientItems().length < config.perPage) {
      config.type = 'slide';
      config.perPage = this.getVisibleIngredientItems().length;
      config.arrows = false;
      config.height = 'revert';
    }
    this.Slider = new Splide('#splide-ingredients', config).mount();
    this.Slider.remove('.hide');
  }

  removeSlider() {
    this.Slider.destroy();
  }

  setIngredientLinks() {
    this.getIngredientLinks().forEach(ingredientLink => {
      ingredientLink.addEventListener('click', e => {
        e.preventDefault();
        const ingredientHandle = ingredientLink.dataset.ingredient;
        this.setPushState(ingredientLink.href);
        this.displayIngredientOverlay(ingredientHandle);
      });
    });
  }

  getIngredientData = (handle) => {
    const ingredientData = this.data.glossaryData.find(ingredient => ingredient['Name'].replace(/\s+/g, '-').toLowerCase() === handle);
    return ingredientData || '';
  }

  getIngredientCard(data) {
    const ingredientCard = this.cardTemplate.content.cloneNode(true);

    this.ingredientCard.innerHTML = '';
    this.ingredientCard.appendChild(ingredientCard);

    // Overlay Events (will move out eventually since it's firing on every open)
    this.ingredientCardClose = this.ingredientOverlay.querySelector('.js-ingredient-overlay-close');
    this.ingredientCardClose.addEventListener('click', e => {
      e.preventDefault();
      this.hideIngredientOverlay();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.hideIngredientOverlay();
      }
    });

    // Title
    this.ingredientTitle = this.ingredientOverlay.querySelector('.js-ingredient-title');
    this.ingredientTitle.innerHTML = data['Name'];

    // Full Image
    this.ingredientImage = this.ingredientOverlay.querySelector('.js-ingredient-image');
    this.ingredientImage.src = data['Full Image Path'];
    this.ingredientImage.alt = "Image of " + data['Name'];

    // Description
    this.ingredientDesc = this.ingredientOverlay.querySelector('.js-ingredient-description');
    this.ingredientDesc.innerHTML = data['Description'];

    // Did You Know?
    this.ingredientDidYouKnow = this.ingredientOverlay.querySelector('.js-ingredient-did-you-know');
    this.ingredientDidYouKnow.innerHTML = data['Did you know?'] || 'More Info To Come!';

    // EWG Score
    this.ingredientEWG = this.ingredientOverlay.querySelector('.js-ingredient-ewg');
    this.ingredientEWG.innerHTML = data['EWG Score'] || '';

    // Category
    this.ingredientCategory = this.ingredientOverlay.querySelector('.js-ingredient-type');
    this.ingredientCategory.innerHTML = data['Ingredient Type'] || '';
    this.ingredientCategory.href = data['Ingredient Type Path'] || '';

    // Found In
    this.ingredientFoundInList = this.ingredientOverlay.querySelector('.js-ingredient-found-in');
    for (let i = 0; i < 3; i++) {
      const foundInData = data[`Found In ${i}`];
      const foundInLinkData = data[`Found In Link ${i}`];
      if (foundInData) {
        const foundInItem = document.createElement('li');
        // Add a link if a link is provided
        if (foundInLinkData) {
          const foundInLink = document.createElement('a');
          foundInLink.href = foundInLinkData;
          foundInLink.innerHTML = foundInData;
          foundInItem.appendChild(foundInLink);
        } else {
          foundInItem.innerHTML = foundInData;
        }
        this.ingredientFoundInList.appendChild(foundInItem);
      }
    }

    // Benefits
    this.ingredientBenefitsList = this.ingredientOverlay.querySelector('.js-ingredient-benefits');
    if (this.ingredientBenefitsList) {
      this.ingredientBenefitsList.innerHTML = '';
    }
    for (let i = 0; i < 4; i++) {
      const benefitIconData = data[`Benefit ${i} Icon Path`];
      const benefitTextData = data[`Benefit ${i} Text`];
      if (benefitTextData && benefitIconData) {
        const benefitItem = document.createElement('li');
        const benefitIcon = document.createElement('img');
        const benefitText = document.createElement('span');
        benefitIcon.src = benefitIconData;
        benefitIcon.alt = `${benefitTextData} Icon`;
        benefitItem.appendChild(benefitIcon);
        benefitText.innerHTML = benefitTextData;
        benefitItem.appendChild(benefitText);
        if (this.ingredientBenefitsList) {
          this.ingredientBenefitsList.appendChild(benefitItem);
        }
      }
    }

    // Shop By Ingredient
    this.ingredientShopBy = this.ingredientOverlay.querySelector('.js-ingredient-shop-by');
    this.ingredientShopBy.href = data['Collection Page Link'] || '';

    this.ingredientOverlay.classList.add('show-overlay');
  }

  displayIngredientOverlay(handle) {
    const data = this.getIngredientData(handle);
    if (data) {
      this.getIngredientCard(data);
    } else {
      console.log('No data found');
    }
  }

  hideIngredientOverlay() {
    if (this.ingredientOverlay.classList.contains('show-overlay')) {
      this.ingredientOverlay.classList.remove('show-overlay');
    }
  }

  checkMobileContentDisplay() {
    const queryString = window.location.href.split('?')[1];
    const hasCategory = queryString?.includes('category');
    const hasLetter = queryString?.includes('letter');
    if (hasCategory || hasLetter) {
      this.displayIngredientsContent();
    }
  }
}

customElements.define('glossary-ingredients', GlossaryIngredients);